/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import {
  StyledCancelButton,
  StyledCheckbox,
  StyledConfirmButton,
  StyledConfirmDeleteContainer,
  StyledConfirmMessage,
  StyledDialogTitle,
  StyledIconButton,
  StyledIconContainer,
  StyledDialogContentText,
} from "./styles";
import { useTranslation } from "react-i18next";
import { LoadingSpinner } from "../loading_spinner";

export const ConfirmationDialog = ({
  open,
  onClose,
  Icon,
  dialogTitle,
  dialogBody,
  confirmationText,
  handleConfirm,
  isLoading = false,
  dataTestId = ''
}) => {
  const [confirm, setConfirm] = useState(false);

  const { t } = useTranslation();

  const isDiscountCardsPath =
    /^\/admin\/perq_cards\/?$/.test(location.pathname) ||
    /^\/admin\/perq_cards\/create\/?$/.test(location.pathname) ||
    /^\/admin\/perq_cards\/edit\/\d+\/?$/.test(location.pathname);

  return (
    <React.Fragment>
      <Dialog
        data-testid={dataTestId}
        open={open}
        onClose={() => {
          onClose();
          setConfirm(false);
        }}
      >
        <StyledIconContainer>
          <StyledIconButton disableRipple>
            <Icon sx={{ color: "#ff4c00", fontSize: "30px" }} />
          </StyledIconButton>
        </StyledIconContainer>

        <StyledDialogTitle>{dialogTitle}</StyledDialogTitle>

        <DialogContent>
          <StyledDialogContentText>
            {dialogBody}
          </StyledDialogContentText>

          <StyledConfirmDeleteContainer>
            <StyledCheckbox
              disableRipple
              size="small"
              onClick={() => setConfirm(!confirm)}
              data-testid='confirm-checkbox'
            />
            <StyledConfirmMessage>{confirmationText}</StyledConfirmMessage>
          </StyledConfirmDeleteContainer>
        </DialogContent>

        <DialogActions sx={{ marginBottom: "3%" }}>
          <StyledCancelButton
            onClick={() => {
              onClose();
              setConfirm(false);
            }}
          >
            {isDiscountCardsPath ? t("confirmation-dialog.cancel") : "Cancel"}
          </StyledCancelButton>
          <StyledConfirmButton
            variant="contained"
            disabled={!confirm}
            onClick={() => {
              handleConfirm();
              setConfirm(false);
            }}
          >
            {isLoading ? (
              <LoadingSpinner isLoading={true} />
            ) : isDiscountCardsPath ? (
              t("confirmation-dialog.confirm")
            ) : (
              "Confirm"
            )}
          </StyledConfirmButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
